<template>
    <div class="station-boxs">
        <div class="cont-top com-model flex flex-column align-initial flex-between">
            <div class="cont-title flex c-c-c">岗位管理
                <div class="router-contaier flex">
                    <router-link to="/index/posts/release" class="flex c-btn m-l-24">
                        发布岗位
                    </router-link>
                    <!-- to="/index/posts/ai" -->
                    <div class="to-batch-release-ai flex" @click="openBatchAiDialog">
                        <font>AI</font>Ai帮你批量发岗位
                    </div>
                </div>
            </div>
            <el-tabs class="ac-tabs" v-model="tabindex" @tab-click="handleClick">
                <template v-for="(item, index) in tabList" >
                    <el-tab-pane v-if="index!=1" :index="index" :label="item" :name='index.toString()' :key="index"></el-tab-pane>
                </template>
            </el-tabs>
        </div>

        <template v-if="checkList && checkList.length">
            <div class="checked-all-box" v-show="rowList.length">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-button
                    type="primary"
                    plain
                    v-for="btn in checkList"
                    :key="btn"
                    @click="handleBatch(btn)"
                    :disabled="!checkedIdList.length"
                >{{ btn }}</el-button>
            </div>
        </template>

        <div  style="margin-top: 4px">
            <div class="stationbox com-model" style="padding: 28px 0">
                <template  v-if="pageTotal">
                    <el-checkbox-group :class="{'c-el-checkbox': true, 'no-checkbox': !checkList || !checkList.length}" v-model="checkedIdList" @change="handleCheckedidList">
                        <el-checkbox :label="item.id" v-for="item in rowList" :key="item.id">

                            <div class="stationbox-item clearfix">
                                <div class="stationbox-item-top clearfix">
                                    <div class="title-info">
                                        <div class="stat-tit">
                                            <span>{{item.title}}</span>
                                            <div class="value qr-img" @click="getWechatCode(item.id)">
                                                <img src="../../assets/images/icon_code.png" />
                                            </div>
                                            <img v-if="item.videoUrl" class="icon-img" src="../../assets/images/icon_movie.png" @click="handlePreview(item.videoUrl)" />
                                        </div>

                                        <div class="right">
                                            <div class="r-item">查看岗位<span>{{ item.viewsCount }}</span>次</div>
                                            <div class="r-item">获取电话<span>{{ item.getPhoneCount }}</span>次</div>
                                            <div class="r-item">简历收到<span>{{ item.deliverCount }}</span>份</div>
                                        </div>
                                    </div>
                                    <div class="stat-treat-money">￥{{item.minSalary}} - {{item.maxSalary}}</div>
                                    <dl class="stat-dl-require flex">
                                        <dd>
                                            <span class="stat-dl-retit">性别要求：</span>
                                            <span class="stat-dl-rename">{{item.requireSex | sexsel}}</span>
                                        </dd>
                                        <dd>
                                            <span class="stat-dl-retit">年龄要求：</span>
                                            <span class="stat-dl-rename">{{item.requireMinage}}-{{item.requireMaxage}}岁</span>
                                        </dd>
                                        <dd>
                                            <span class="stat-dl-retit">学历要求：</span>
                                            <span class="stat-dl-rename">{{item.requireEdu | edusel(eduList)}}</span>
                                        </dd>
                                        <dd>
                                            <span class="stat-dl-retit">经验要求：</span>
                                            <span class="stat-dl-rename">{{item.requireExp | expsel(expList)}}</span>
                                        </dd>
                                    </dl>
                                    <!-- <div class="stat-welfare" v-if="item.welfare">
                                        <div v-for="it in item.welfare.split(':')">{{it}}</div>
                                    </div> -->
                                </div>
                                <!-- 待遇 -->
                                <div class="stat-list flex">
                                    <div class="stat-item" v-if="item.provideCarsubsidy"><span>车</span>车补{{item.carsubsidy}}元/人</div>
                                    <div class="stat-item" v-if="item.rewardStatus === 1" @click.stop="handleOpera(item)">悬赏转发</div>
                                </div>
                                <div class="stationbox-item-bottom flex flex-between">
                                    <div class="stat-release flex flex-between">
                                        <div class="flex">
                                            <p>发布者：</p>
                                            <div class="stat-img">
                                                <img :src="item.hrHeadImage ? item.hrHeadImage : '//oss.51ztx.com/face.png'">
                                            </div>
                                            <p>{{item.hrName}}</p>
                                        </div>

                                    </div>
                                    <p v-if="item.createAt" class="time">创建时间{{item.createAt.slice(0, -2)}}</p>
                                    <div class="stat-btn-group">
                                        <!-- <el-dropdown split-button type="primary" @command="handleOperaChange">
                                            效果提升
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item>悬赏转发</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown> -->

                                        <div class="stat-btn-group-main" v-if="tabindex == 0">
                                            <!-- <el-button @click.stop="handleOpera(item)">悬赏转发</el-button> -->
                                            <div class="stat-btn primary-border-btn" @click.stop="handleOpera(item)">悬赏转发</div>
                                            <div class="stat-btn error-border-btn" @click="postOffline(item.id)">下线</div>
                                            <div class="stat-btn primary-border-btn" @click="edit(item.id)">编辑岗位</div>
                                            <div class="stat-btn warning-border-btn" @click.stop="refresh(item.id)">岗位刷新</div>
                                            <!-- <div class="stat-btn stat-btn-blue" @click="postRecruiteFull(item.id)">已招满</div> -->
                                        </div>
                                        <div class="stat-btn-group-main" v-if="tabindex == 1">
                                            <div class="stat-btn primary-border-btn" @click="republish(item.id)">重新上线</div>
                                        </div>
                                        <div class="stat-btn-group-main" v-if="tabindex == 2">
                                            <div class="stat-btn error-border-btn" @click="postDelete(item.id)">删除</div>
                                            <div class="stat-btn primary-border-btn" @click="edit(item.id)">编辑岗位</div>
                                            <!--<div class="stat-btn stat-btn-blue">上线</div>-->
                                        </div>
                                        <div class="stat-btn-group-main" v-if="tabindex == 3">
                                            <div class="stat-btn error-border-btn" @click="postDelete(item.id, true)">删除</div>
                                            <div class="stat-btn primary-border-btn" @click="republish(item.id)">重新上线</div>
                                        </div>
                                        <div class="stat-btn-group-main" v-if="tabindex == 4">
                                            <div v-if="item.status*1 === 0">
                                                <div class="stat-btn error-border-btn" @click="cancelAudit(item.id)">取消审核</div>
                                                <div class="stat-btn gray-border-btn" style="cursor:text;">审核中</div>
                                            </div>
                                            <div v-else>
                                                <p class="stat-examine-lose" v-if="item.status*1 === -1">
                                                    审核失败，{{item.auditRemark}}</p>
                                                <p class="stat-examine-suc flex" v-if="item.status*1 === 1">
                                                    <i class = "el-icon-check"></i>
                                                    审核成功，请随时留意线上岗位状态</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </el-checkbox>
                    </el-checkbox-group>
                    <div>

                    </div>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageTotal">
                    </el-pagination>
                </template>
                <template v-else>
                    <no-data />
                </template>
            </div>
        </div>

        <el-dialog title="视频预览" :visible.sync="videoVisible">
            <video controls loop style="width: 100%; height: 100%" :src="videoUrl"  v-if="videoUrl && videoVisible" autoplay></video>
        </el-dialog>
        <el-dialog v-model="imageVisible" size="tiny">
          <img width="100%" :src="imageUrl" alt="">
        </el-dialog>

        <DialogUpload :show.sync="visiableUpload" />
        <Config :show.sync="configVisible" :id="rewardInfo.id" @refresh="handleRefresh" />
        <RForm :show.sync="formVisible" type="rewordType" v-bind="rewardInfo" @refresh="handleRefresh" @history="handleToHistory" @toConfig="handleToConfig" />
        <HistoryDetail :show.sync="historyDetailVisible" v-bind="rewardInfo" />
    </div>
</template>
<script>
    import NoData from '../../components/NoData'
    import DialogUpload from '@/components/PostBatchUpload.vue'
    import Config from '@/components/reword/Config.vue'
    import RForm from '@/components/reword/Form.vue'
    import HistoryDetail from '@/components/reword/HistoryDetail.vue'

    const checkListInfo = {
        2: ['批量删除'],
        3: ['批量上线', '批量删除']
    }

    export default {
        data() {
            return {
                pageNum: 1,
                pageSize: 10,
                tabList: ['招聘中', '已招满', '未发布', '已下架', '审核记录'],
                tabindex: 0,
                expList: [], // 经验列表
                eduList: [], // 学历列表
                rowList: [],
                pageTotal: -1,

                videoVisible: false,
                videoUrl: '',

                isIndeterminate: false,
                checkAll: false,
                checkedIdList: [],
                imageVisible: false,
                imageUrl: '',
                visiableUpload: false,
                configVisible: false,
                formVisible: false,
                historyDetailVisible: false,
                rewardInfo: {
                    rewardStatus: 0,
                    id: '',
                    postTitle: ''
                }
            }
        },
        computed: {
            checkList() {
                return checkListInfo[Number(this.tabindex)] || []
            }
        },
        created() {
            this.getAIToken()
        },
        watch: {
            pageNum(newVal, oldVal) {
                this.selTabEvents(this.tabindex);
            }
        },
        components: {
            NoData,
            DialogUpload,
            Config,
            RForm,
            HistoryDetail
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.getExp();
                vm.getEdu();
            })
        },
        filters: {
            edusel(val, eduList) {
                let edutxt = '不限';
                let educur = eduList.find(function (value, index, arr) {
                    return value.id * 1 == val;
                })
                if (educur) {
                    edutxt = educur.name
                }
                return edutxt;
            },
            expsel(val, expList) {
                let exptxt = '不限';
                let expcur = expList.find(_j => _j.id == val);
                if (expcur) {
                    exptxt = expcur.name;
                }
                return exptxt;
            },
            sexsel(val) {
                if (val == -1) {
                    return '不限';
                } else if (val == 0) {
                    return '女'
                } else {
                    return '男';
                }
            },
            welfareFilter(val) {
                return val.split(':').join(',');
            }
        },
        methods: {
            getAIToken() {
                let ai_token = window.localStorage.getItem('ai_token')
                if (ai_token) return

                this.axios.get('https://df-api.yifu-tech.com/api/passport', {
                    headers: {
                        'x-app-code': 'mBscOBOYRQYXZC3q'
                    }
                })
                    .then(res => {
                        window.localStorage.setItem('ai_token', `Bearer ${res.access_token}`)
                    })
            },
            openBatchAiDialog() {
                this.visiableUpload = true
            },
            handleCurrent(val) {
                this.pageNum = val;
            },
            edit(id) {
                this.$router.push({path: '/index/posts/edit', query: {cuid: id, tab: this.tabindex}})
            },
            // 招聘中刷新
            refresh(id) {
                this.axios.get('/wapi/hr/recruit/refresh?recruitId=' + id)
                    .then(res => {
                        if (res.success) {
                            this.$message('已刷新');
                            this.pageRecruiting();
                        }
                    })
            },
            toFailViewByRecruit(id) {
                this.$ztxConfirmH(
                  '您希望下架的岗位还存在未处理的简历，您可以前往岗位简历管理页面处理，也可以选择批量处理简历并直接下架岗位。',
                  '确认下架该岗位',
                  {
                      canceltxt:'我自己处理',
                      confirmtxt:'批量处理并下架岗位'
                  }
                ).then(() => {
                    let formdata = new FormData();
                    formdata.append('recruitId', id);
                    this.axios.post('/wapi/hr/resume/failViewByRecruit', formdata).then(res => {
                          if (res.status === 200) {
                              this.$message('已批量处理并下架岗位');
                              this.pageRecruiting();
                          }
                      })
                }).catch(() => {
                    this.$router.push({ path: '/index/resume/list', query:{ index: 2 } });
                });
            },
            // 招聘中下线岗位
            postOffline(id) {
                this.$ztxConfirm('请检查此岗位是否有人投递，未结束投递将不可下架，已下架岗位可在已下架列表中查看。','下架岗位').then(res => {
                    postOfflineId();
                }).catch();
                let self = this;
                function postOfflineId(){
                    self.axios.get('/wapi/hr/recruit/offline?recruitId=' + id)
                        .then(res => {
                            if (res.status == 200) {
                                self.$message('已下架');
                                self.pageRecruiting();
                            } else if (res.status === 500){
                                self.toFailViewByRecruit(id);
                            }
                        })
                }
            },
            // 招聘中已招满
            postRecruiteFull(id) {
                this.$ztxConfirm('确认此岗位已经招满了吗?已招满岗位可在已招满列表中查看。').then(res => {
                    postRecruiteFullId();
                }).catch(res => {});
                let self = this;
                function postRecruiteFullId() {
                    self.axios.get('/wapi/hr/recruit/recruiteFull?recruitId=' + id)
                        .then(res => {
                            if (res.status == 200) {
                                self.$message('操作成功');
                                self.pageRecruiting();
                            }
                        })
                }

            },
            // 已招满 重新上线
            republish(id, offline= '') {
                // debugger;
                this.$ztxConfirm('岗位重新上线将发布新岗位，您可以直接重新上线，或者修改岗位要求之后再发布','重新上线',{
                    canceltxt:'去修改',
                    confirmtxt:'直接发布'
                }).then(res => {
                    postRepublishId();

                }).catch(res => {
                    this.$router.push({path: '/index/posts/edit', query: {cuid: id, tab: this.tabindex}})
                });
                let self = this;
                function postRepublishId() {
                    self.axios.get('/wapi/hr/recruit/republish?recruitId=' + id)
                        .then(res => {
                            if (res.status == 200) {
                                self.$message(res.msg);
//                                if (offline){
//                                    this.pageOffline();
//                                    return;
//                                }
//
//                                self.pageRecruited();
                            }
                        })
                }
            },
            // 未发布 删除
            postDelete(id, offline) {
                this.$ztxConfirm('确认要删除此岗位吗，删除之后将不可恢复。', '删除岗位').then(res => {
                    postDeleteId();
                }).catch(res => {
                })
                let self = this;
                function postDeleteId() {
                    self.axios.get('/wapi/hr/recruit/delete?recruitId=' + id)
                        .then(res => {
                            if (res.status == 200) {
                                self.$message('已删除');
                                if (offline) {
                                    self.pageOffline();
                                    return;
                                }
                                self.pageNotPub();
                            }
                        })
                }

            },
            // 审核中 取消审核
            cancelAudit(id) {
                this.axios.get('/wapi/hr/recruit/cancelAudit?recruitId=' + id)
                    .then(res => {
                        if (res.success) {
                            this.$message('已取消');
                            this.pageAudit();
                        }
                    })
            },
            getExp() {
                this.axios.get('/wapi/baseData/listExperience').then(res => {
                    this.expList = res.data;
                })
            },
            getEdu() {
                this.axios.get('/wapi/baseData/listEducation').then(res => {
                    this.eduList = res.data;
                })
            },
            tabsChange(val) {
                this.tabindex = val;
                this.pageNum = 1;
                this.selTabEvents(val);
            },
            handleSizeChange (val){
                this.pageSize = val
                this.selTabEvents(this.tabindex);
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.selTabEvents(this.tabindex);
            },
            handleClick (type) {
                console.log('type', type)
                this.tabindex = type.name;
                this.pageNum = 1;
                console.log(type.name)
                this.resetCheckInfo()
                this.selTabEvents(type.name);
            },
            resetCheckInfo() {
                this.checkedIdList = []
                this.checkAll = false
                this.isIndeterminate = false
            },
            selTabEvents(n) {
                const index = Number(n)
                switch (index) {
                    case 0:
                        this.pageRecruiting();
                        break;
                    case 1:
                        this.pageRecruited();
                        break;
                    case 2:
                        this.pageNotPub();
                        break;
                    case 3:
                        this.pageOffline();
                        break;
                    default:
                        this.pageAudit();
                }
            },
            // 招聘中列表
            pageRecruiting() {
                let url = '/wapi/hr/recruit/pageRecruiting?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize;
                this.axios.get(url)
                    .then(res => {
                        this.rowList = res.rows;
                        this.pageTotal = res.total;
                    })
            },
            // 已招满列表
            pageRecruited() {
                let url = '/wapi/hr/recruit/pageRecruited?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize;
                this.axios.get(url)
                    .then(res => {
                        this.rowList = res.rows;
                        this.pageTotal = res.total;
                    })
            },
            // 未发布列表
            pageNotPub() {
                let url = '/wapi/hr/recruit/pageNotPub?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize;
                this.axios.get(url)
                    .then(res => {
                        this.rowList = res.rows;
                        this.pageTotal = res.total;
                    })
            },
            // 待审核
            pageAudit() {
                let url = '/wapi/hr/recruit/pageAudit?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize;
                this.axios.get(url)
                    .then(res => {
                        this.rowList = res.rows;
                        this.pageTotal = res.total;
                    })
            },
            // 下线列表
            pageOffline() {
                let url = '/wapi/hr/recruit/pageOffline?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize;
                this.axios.get(url)
                    .then(res => {
                        this.rowList = res.rows;
                        this.pageTotal = res.total;
                    })
            },
            handlePreview(videoUrl) {
                this.videoVisible = true
                this.videoUrl = videoUrl
            },

            // 批量操作
            handleCheckAllChange(event) {
                const complateList = this.rowList.map(v => v.id)
                this.checkedIdList = event.target.checked ? complateList : [];
                this.isIndeterminate = false;
            },
            handleCheckedidList(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.rowList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.rowList.length;
            },
            handleBatch(type) {
                if (type === '批量删除') {
                    this.batchDelete()
                } else if (type === '批量上线') {
                    this.batchRepublish()
                }

                console.log('type--', type)
                console.log('checkedIdList--', this.checkedIdList)
            },
            batchDelete() {
                this.$ztxConfirm('确认删除全部所选岗位吗？', '删除岗位').then(res => {
                    deleteFn();
                }).catch(res => {
                });
                let self = this;

                function deleteFn() {
                    let url = `/wapi/hr/recruit/delete/batch`;
                    self.axios.post(url, {
                        recruitIdList: self.checkedIdList
                    })
                        .then(res => {
                            if (res.status == 200) {
                                self.$message('已删除');
                                self.selTabEvents(self.tabindex)
                                self.resetCheckInfo()
                            }
                        })
                }
            },
            batchRepublish() {
                // debugger;
                this.$ztxConfirm('确认重新上线全部所选岗位吗','重新上线',{
                    canceltxt:'取消',
                    confirmtxt:'确定'
                }).then(res => {
                    postRepublishId();

                }).catch(res => {
                });
                let self = this;
                function postRepublishId() {
                    let url = `/wapi/hr/recruit/mPublish/batch`;
                    self.axios.post(url, {
                        recruitIdList: self.checkedIdList
                    })
                        .then(res => {
                            if (res.status == 200) {
                                self.$message(res.msg);
                                self.selTabEvents(self.tabindex)
                                self.resetCheckInfo()
                            }
                        })
                }
            },
            getWechatCode(id) {
                let url = `/wapi/hr/recruit/miniCode?recruitId=${id}`;
                this.axios.get(url).then(res => {
                    this.imageUrl = `data:image/jpeg;base64,${res}`
                    this.imageVisible = true
                })
            },
            handleOpera(item) {
                const { rewardStatus, id, title: postTitle} = item
                this.rewardInfo = { rewardStatus, id, postTitle }
                if (rewardStatus === 0) {
                    this.configVisible = true
                } else {
                    this.formVisible = true

                }
            },
            handleRefresh() {
                this.handleClick({ name: this.tabindex })
            },
            handleToHistory() {
                this.historyDetailVisible = true
            },
            handleToConfig() {
                this.configVisible = true
            }
        },
        mounted() {
            if (this.$route.query.openAiUpload) {
                this.openBatchAiDialog()
            }
            const jumpTabIndex = this.$route.query.tabindex
            if (jumpTabIndex) {
                this.handleClick({ name: jumpTabIndex })
            } else {
                this.pageRecruiting();
            }
        }
    }
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
    @import "../../assets/css/station";
.cont-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
    .stat-list{
        position: absolute;
        right: 32px;
        bottom: 110px;
        .stat-item{
            display: flex;
            line-height: 24px;
            border-radius: 4px;
            border: 2px solid #FF7A45;
            text-align: center;
            padding-right: 8px;
            font-size: 16px;
            color: #FF7A45;
            margin-left: 32px;
            span{
                width: 26px;
                height: 24px;
                background: #FF7A45;
                margin-right: 8px;
                font-size: 20px;
                color: #fff;
            }
        }
    }
    .stationbox {
        position: relative;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .ztx-paging {
        background-color: #fff;
        padding-bottom: 22px;
    }

    .title-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .stat-tit {
            display: flex;
            align-items: center;
        }
        .icon-img {
            width: 18px;
            height: 18px;
            margin-left: 15px;
            cursor: pointer;
        }
        .qr-img {
            display: flex;
            align-items: flex-start;
            width: 18px;
            height: 18px;
            margin-left: 15px;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .right {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #999;
            .r-item {
                margin-right: 15px;
            }
            span {
                color: #333333;
                font-size: 18px;
                margin: 0 2px;
            }
        }
    }

    /deep/ .c-el-checkbox {
        // width: 100% !important;
        padding-left: 10px;
        .el-checkbox {
            display: flex;
            align-items: flex-start;
            width: 100%;
            .el-checkbox__label {
                width: 100%;
            }
            .el-checkbox__input {
                padding-top: 5px;
            }
        }
        .el-checkbox+.el-checkbox {
            margin-left: 0;
        }
    }
    /deep/ .no-checkbox {
        .el-checkbox__input {
            display: none;
        }
    }
    .checked-all-box {
        display: flex;
        align-items: center;
        padding: 10px 28px;
        background: #ffffff;
        margin: 4px 0 0;
        >* {
            margin-right: 20px;
        }
    }
    .c-c-c {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .router-contaier {
        margin-right: 24px;
        .c-btn {
            justify-content: center;
            width: 88px;
            height: 32px;
            background: linear-gradient( 90deg, #057CF9 0%, #1AAFFD 100%);
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
        }
        .to-batch-release-ai {
            margin-left: 10px;
            justify-content: center;
            width: 170px;
            height: 32px;
            background: linear-gradient( 180deg, #EAF3FF 0%, #ECFAFF 100%), radial-gradient( 136% 79% at 70% 89%, rgba(149,234,229,0.7) 0%, rgba(158,239,227,0) 100%), radial-gradient( 136% 79% at 9% -1%, #95EAE5 0%, rgba(158,239,227,0) 100%);
            border-radius: 4px;
            font-weight: bold;
            font-size: 15px;
            color: #000000;
            cursor: pointer;
            font {
                width: 24px;
                height: 24px;
                background: linear-gradient( 57deg, #25D2F4 0%, #7392F8 51%, #CC4DFE 100%), radial-gradient( 50% 50% at 47% 46%, #CF4AFE 0%, rgba(204,76,254,0) 100%);
                box-shadow: inset 0px 0px 3px 0px #DE87FF;
                border: 0px solid rgba(255,255,255,0.2);
                border-radius: 50%;
                text-align: center;
                line-height: 24px;
                color: rgba(255, 255, 255, 1);
                font-size: 13px;
                margin-right: 6px;
            }
        }
    }
    .stat-btn-group {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// list.vue?159dfbdb